import { getQueryParams } from '@/infrastructure/Utils'
const mixin = {
  methods: {
    getEmployeeCode() {
      const { employeeCode } = getQueryParams(window.location.search)
      this.employeeCode = employeeCode?.slice(0, 10)
    },
    getOriginPropertyId() {
      const { originPropertyId } = getQueryParams(window.location.search)
      this.originPropertyId = originPropertyId
    }
  },
  mounted() {
    this.getEmployeeCode()
    this.getOriginPropertyId()
  },
  data: () => ({
    employeeCode: '',
    originPropertyId: ''
  })
}

export default mixin
